import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import {FC} from "react";
import {Button, Empty, Spin, Table, Tooltip} from "antd";
import useSurgeryRequestsTableService from "./surgeryRequestsTableService";
import {SurgeryRequestsTableProps} from "./types";
import "./style.less";
import dayjs from "dayjs";
import {useAuth} from "../../../../context/authContext";
import {canEditSurgeryRequest} from "../../../../helpers/canEditSurgeryRequest";
import {useDevice} from "../../../../context/deviceContext";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  EyeOutlined,
  MedicineBoxOutlined,
  UserOutlined
} from "@ant-design/icons";

const SurgeryRequestsTable: FC<SurgeryRequestsTableProps> = ({surgeryRequestsController}) => {
  const {
    list,
    isLoading,
    detailsButtonHandler,
    editButtonHandler,
    confirmDeleteSurgeryRequest
  } = surgeryRequestsController;
  const {columns} = useSurgeryRequestsTableService({
    detailsButtonHandler,
    editButtonHandler,
    confirmDeleteSurgeryRequest
  });
  const {currentUser, isAdmin} = useAuth();
  const {isMobile} = useDevice();

  const getRowClassName = (record: typeof list[number]) => {
    const isPast = dayjs(record.operationTime).isBefore(dayjs());

    if (isPast) return "pastOperationRow";
    return "";
  };

  return <section className="surgery-requests-section">
    <Spin spinning={isLoading}>
      {!list.length && !isLoading ? <div className="surgery-requests-empty">
        <Empty description={isAdmin ? "Заявок на операції поки немає" : "У вас поки немає заявок на операції"}/>
      </div> : isMobile ? <div className="surgery-requests-mobile-list">
        {list.map((item) => {
          const isMine = item.createdById === currentUser?.id;
          const isPast = dayjs(item.operationTime).isBefore(dayjs());
          return <article
            className={`surgery-request-card ${isPast ? "surgery-request-card--past" : ""}`}
            key={item.$id || `${item.operationTime}-${item.patientName}`}>
            <div className="surgery-request-card__header">
              <div className="surgery-request-card__date">
                <CalendarOutlined/>
                <span><strong>{dayjs(item.operationTime).format("DD.MM.YYYY")}</strong>
                  <small>{dayjs(item.operationTime).locale('uk').format('dddd')}</small>
                  <small><ClockCircleOutlined/> {dayjs(item.operationTime).format("HH:mm")}</small></span>
              </div>
              <span className={`surgery-request-card__status ${isPast ? "surgery-request-card__status--past" : ""}`}>
                {isPast ? "Завершено" : "Заплановано"}
              </span>
            </div>

            <div className="surgery-request-card__room">
              <MedicineBoxOutlined/> {item.operationRoom?.name || "Операційну не вказано"}</div>
            <div className="surgery-request-card__details">
              <div><span>Пацієнт</span><strong>{item.patientName || "Не вказано"}</strong></div>
              <div><span>Автор заявки</span><strong><UserOutlined/> {item.author || "Не вказано"}</strong></div>
            </div>

            <div className="surgery-request-card__actions">
              <Button icon={<EyeOutlined/>} onClick={() => detailsButtonHandler(item)}>Детальніше</Button>
              <ActionsMenu
                onEdit={canEditSurgeryRequest(item, currentUser?.id) ? () => editButtonHandler(item) : undefined}
                onDelete={isMine ? () => item.$id && confirmDeleteSurgeryRequest(item.$id) : undefined}
              />
            </div>
          </article>;
        })}
      </div> : <div className="surgery-requests-table-shell">
        <Table
          className="surgeryRequestsTable"
          bordered
          loading={false}
          pagination={false}
          columns={columns}
          dataSource={list}
          rowKey={(record) => record.$id || `${record.operationTime}-${record.patientName}`}
          scroll={{x: "max-content"}}
          rowClassName={getRowClassName}
        />
      </div>}
    </Spin>
  </section>;
};

export default SurgeryRequestsTable;
